// extracted by mini-css-extract-plugin
export var avatarContainer = "_a9-0";
export var avatarTypingWave = "_a9-i";
export var gray = "_a9-f";
export var green = "_a9-c";
export var icon = "_a9-9";
export var image = "_a9-1";
export var lg = "_a9-6";
export var md = "_a9-5";
export var presenceDot = "_a9-b";
export var red = "_a9-d";
export var sm = "_a9-4";
export var status = "_a9-a";
export var typingDot = "_a9-h";
export var typingPill = "_a9-g";
export var xl = "_a9-7";
export var xs = "_a9-3";
export var xxl = "_a9-8";
export var xxs = "_a9-2";
export var yellow = "_a9-e";